import { Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { alpha } from '@mui/material/styles';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: any) => ({
  container: {
    padding: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
    backgroundColor: alpha(theme.palette.info.main, 0.12),
  },
  message: {
    color: theme.palette.text.primary,
    textAlign: 'center',
  },
}));

type EmptyStateProps = {
  message?: string;
};

const EmptyState: FC<EmptyStateProps> = ({ message }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid item className={classes.container}>
      <Typography variant="body2" className={classes.message}>
        {message || t('contact:noInformationAvailableMessage')}
      </Typography>
    </Grid>
  );
};

export default EmptyState;